import React from 'react';

/**
 * Component for displaying certification badges
 * @param {Object} props - Component props
 * @param {Array} props.items - Array of badge objects
 * @param {string} [props.className] - Additional CSS classes
 * @returns {React.ReactElement} BadgesRow component
 */
const BadgesRow = ({ items, className = '' }) => {
  return (
    <div className={`flex flex-wrap justify-center gap-12 ${className}`}>
      {items.map((badge) => (
        <div 
          key={badge.name} 
          className="flex flex-col items-center"
          title={badge.alt}
        >
          <img 
            src={`/assets/badges/${badge.svg}`} 
            alt={badge.alt} 
            className="h-48 mb-4"
          />
          <span className="text-xl font-medium">{badge.name}</span>
        </div>
      ))}
    </div>
  );
};

export default BadgesRow;
